module.exports = __webpack_public_path__ + "img/img-food.c86664d4.png";